import React from 'react';

const ICONS = {
  select: (
    <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden>
      <path d="M3 2l10 5-4 1-1 4-5-10z" fill="currentColor" />
    </svg>
  ),
  place: (
    <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden>
      <path
        d="M8 2v12M2 8h12"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
    </svg>
  ),
  measure: (
    <svg viewBox="0 0 16 16" width="16" height="16" aria-hidden>
      <path
        d="M2 10l8-8 4 4-8 8z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.3"
      />
      <path
        d="M5 8l1 1M7 6l1 1M9 4l1 1"
        stroke="currentColor"
        strokeWidth="1.3"
      />
    </svg>
  ),
};

const TOOLS = [
  { id: 'select', key: 'V', title: 'Select' },
  { id: 'place', key: 'P', title: 'Place' },
  { id: 'measure', key: 'M', title: 'Measure' },
];

export default function DesignToolRail({ tool, onToolChange }) {
  return (
    <div className="rail" role="toolbar" aria-label="Design tools">
      {TOOLS.map((t) => (
        <button
          key={t.id}
          type="button"
          className={`rail-btn${tool === t.id ? ' active' : ''}`}
          title={`${t.title} (${t.key})`}
          aria-pressed={tool === t.id}
          onClick={() => onToolChange(t.id)}
        >
          {ICONS[t.id]}
          <span className="k">{t.key}</span>
        </button>
      ))}
    </div>
  );
}
